var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.576 4.10391V4.00391H24.5692C24.5184 2.36862 23.226 1.05625 21.6283 1.05625H3.37168C1.74157 1.05625 0.429297 2.42245 0.429297 4.10391V17.8469C0.429297 19.5283 1.74157 20.8945 3.37168 20.8945H21.6336C23.2637 20.8945 24.576 19.5283 24.576 17.8469V4.10391ZM12.7832 10.3277L12.7704 10.3349L12.7681 10.3373C12.7674 10.3377 12.7667 10.3381 12.766 10.3386C12.7635 10.3402 12.761 10.3419 12.7584 10.3439C12.6031 10.4348 12.4062 10.4346 12.251 10.3433C12.2436 10.3379 12.2368 10.3344 12.232 10.3321C12.2286 10.3305 12.2255 10.3292 12.2232 10.3283L12.222 10.3277L1.89492 4.52663V4.12578C1.89492 3.27433 2.57157 2.56875 3.38223 2.56875H21.623C22.4337 2.56875 23.1104 3.27433 23.1104 4.12578V4.52368L12.7832 10.3277ZM23.1051 17.8742C23.1051 18.7257 22.4284 19.4312 21.6178 19.4312H3.38223C2.57157 19.4312 1.89492 18.7257 1.89492 17.8742V6.24903L11.506 11.6499C12.1171 12.0123 12.8776 12.0123 13.4887 11.6499C13.489 11.6497 13.4894 11.6495 13.4897 11.6493L23.1051 6.24898V17.8742Z",
    fill: "#3774C3",
    stroke: "#3774C3",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6c534be9db790720d422cc07384820fa.svg";
export { ForwardRef as ReactComponent };